/**
 * Qué hacer con cada respuesta de `ready-to-embedded` en el paso de firma.
 *
 * Antes de firmar, el contrato puede regenerarse (el cliente cambia sus datos desde el área de cliente o con Atlas): el
 * sobre que se ve en el iframe se anula y aparece otro. Por eso, con la URL ya enseñada, se sigue preguntando cada
 * `RECHECK_MS`: si llega otra URL, se cambia el iframe; si llega «PENDING» (sin URL, el contrato nuevo se está
 * generando), se vacía y se espera como al principio.
 *
 * En native (gateway) no se repregunta: su llamada es un POST idempotente y su oferta está congelada.
 */
export const RETRY_MS = 5000;
export const RECHECK_MS = 15000;

export type EmbeddedSignature = { url?: string | null } | undefined;

export type SignatureUrlStep =
  | { kind: "show"; url: string; nextCheckMs: number | null }
  | { kind: "keep"; nextCheckMs: number | null }
  | { kind: "wait"; clear: boolean; nextCheckMs: number };

export const nextSignatureUrlStep = (
  shownUrl: string,
  response: EmbeddedSignature,
  recheck: boolean
): SignatureUrlStep => {
  const url = response?.url ?? "";
  const nextCheckMs = recheck ? RECHECK_MS : null;
  if (url === "") {
    return { kind: "wait", clear: shownUrl !== "", nextCheckMs: RETRY_MS };
  }
  if (url !== shownUrl) {
    return { kind: "show", url, nextCheckMs };
  }
  return { kind: "keep", nextCheckMs };
};
